<template>
  <g class="axes" >
    <g :transform="'translate(0,' + height + ')'" ref="axisX" class="axis x" ></g>
    <g ref="axisY" class="axis y" ></g>
    <g v-if="y2" :transform="'translate(' + width + ',0)'" ref="axisY2" class="axis y2" ></g>
    <text
       v-if="xTitle"
       :dx="Array.apply(null, Array(xTitle.length)).map((a, i) => i ? 3 : -xTitle.length * 2).join(' ')"
       dy="-5"
       :transform="'translate(' + width + ',' + height + ') rotate(90)'"
       rotate="-90" >
      {{ xTitle }}
    </text>
    <text v-if="yTitle" text-anchor="middle" dy="-7" >{{ yTitle }}</text>
    <text v-if="y2Title" :transform="'translate(' + width + ',0)'" text-anchor="middle" dy="-7" >
      {{ y2Title }}
    </text>
  </g>
</template>

<script>
import * as d3 from 'd3'
import Vue from 'vue'
import popover from '../mixins/popover.js'

export default {
  props: {
    height: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    x: {
      type: Function,
      default: () => {
        return d3.scaleLinear().rangeRound([0, this.width])
      }
    },
    y: {
      type: Function,
      default: () => {
        return d3.scaleLinear().rangeRound([this.height, 0])
      }
    },
    y2: {
      type: Function
    },
    xFormatter: {
      type: Function
    },
    yFormatter: {
      type: Function
    },
    y2Formatter: {
      type: Function
    },
    xLabelRotate: {
      type: Number,
      default: 0
    },
    xLabelWidth: {
      type: Number,
      default: 100
    },
    xTitle: {
      type: String
    },
    yTitle: {
      type: String
    },
    y2Title: {
      type: String
    },
    ticks: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      popoverDiv: null,
      popover: null
    }
  },
  mounted () {
    this.popoverDiv = document.createElement('div')
    this.popoverDiv.setAttribute('id', 'd3vue-popover-' + this._uid)
    document.getElementsByTagName('body')[0].appendChild(this.popoverDiv)
    this.popover = new Vue({
      el: '#d3vue-popover-' + this._uid,
      mixins: [
        popover
      ],
      data () {
        return {
          text: null,
          component: null
        }
      },
      computed: {
        show () {
          return this.showPopover
        }
      },
      methods: {
        setParent (parent) {
          this.parent = parent
          this.text = d3.select(parent).attr('data-title')
          this.showPopover = true
          this.captureEvents = false
          clearTimeout(this.popTimeout)
        }
      }
    })
  },
  methods: {
    draw () {
      d3.select(this.$refs.axisX).selectAll('*').remove()
      d3.select(this.$refs.axisY).selectAll('*').remove()

      let bottom = d3.axisBottom(this.x).tickSize(-this.height)
      if (this.xFormatter) {
        bottom.tickFormat(this.xFormatter)
      }
      d3.select(this.$refs.axisX)
        .call(bottom)
        .selectAll('text')

      this.shrinkLabels()

      let left = d3.axisLeft(this.y).tickSize(-this.width)
      if (this.yFormatter) {
        left.tickFormat(this.yFormatter)
        left.ticks(this.ticks)
      } else {
        left.ticks(this.ticks, ',f')
      }
      d3.select(this.$refs.axisY).call(left)

      if (this.y2) {
        let right = d3.axisRight(this.y2)
        if (this.y2Formatter) {
          right.tickFormat(this.y2Formatter)
          left.ticks(this.ticks)
        } else {
          right.ticks(this.ticks, ',f')
        }
        d3.select(this.$refs.axisY2).call(right)
      }
    },
    shrinkLabels () {
      const vm = this
      this.$nextTick(() => {
        d3.select(this.$refs.axisX).selectAll('text').each(function () {
          const node = d3.select(this)
          let text = node.text()
          if (!node.classed('shrinked')) {
            node.attr('data-title', text)
          }
          node.classed('shrinked', false)
          while (this.getComputedTextLength() > vm.xLabelWidth && text.length > 3) {
            if (!node.classed('shrinked')) {
              node.classed('shrinked', true)              
            }
            text = text.slice(0, -1)
            node.text(text + '...')
          }
        }).attr('transform', function () {
          const l = this.getComputedTextLength()
          const x = vm.xLabelRotate ? -l * Math.cos(vm.xLabelRotate) * 0.5 : 0
          const y = 10 - l * Math.sin(vm.xLabelRotate) * 0.5
          return 'translate(' + x + ',' + y + ') rotate(' + vm.xLabelRotate + ')'
        })
        d3.select(this.$refs.axisX).selectAll('.shrinked').on('mouseover', function () {
          vm.popover.setParent(this)
        }).on('mouseleave', function () {
          vm.popover.captureEvents = true
          vm.popover.mouseLeave()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/OrthogonalAxes.vue